import { WifiOff } from 'lucide-react';
import { t } from '../lib/copy';
import { useOnline } from '../lib/useOnline';

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-sunrise px-4 py-2 text-sm font-medium text-ink"
    >
      <WifiOff className="size-4" aria-hidden />
      {t('net.offline')}
    </div>
  );
}
